export var QueuePriority;
(function (QueuePriority) {
    QueuePriority[QueuePriority["LOWEST"] = 5] = "LOWEST";
    QueuePriority[QueuePriority["LOW"] = 4] = "LOW";
    QueuePriority[QueuePriority["MEDIUM"] = 3] = "MEDIUM";
    QueuePriority[QueuePriority["HIGH"] = 2] = "HIGH";
    QueuePriority[QueuePriority["HIGHEST"] = 1] = "HIGHEST";
})(QueuePriority || (QueuePriority = {}));
// Connect-time INITIAL-gate poll backoff (the `awaitTransactionsReady` loop). Capped exponential:
// 2s, 4s, 8s, 15s, 15s, … The default 10-attempt budget (set where processPublicToken enqueues)
// then spans ~2+4+8+15*7 ≈ 119s — comfortably longer than a typical Plaid initial pull, and
// aligned with mobile's per-membership sync-wait timeout.
const AWAIT_TXNS_BASE_DELAY_MS = 2000;
const AWAIT_TXNS_MAX_DELAY_MS = 15000;
/**
 * Decides whether the queue worker should re-enqueue another connect-time readiness poll after a
 * `syncMembership` attempt, and with what delay. Pure leaf so it's unit-tested without the queue's
 * bullmq/Firebase imports (roo-shared `tests/awaitTransactionsReEnqueue.test.ts`).
 *
 * @param keepWaiting the sync suppressed its terminal event (transactions still not ready) OR was
 *   skipped because another sync was already running — either way the connect-time spinner should
 *   keep waiting, so poll again. A real success-with-data or a failure passes `false`.
 */
export function planAwaitTransactionsReEnqueue(p) {
    if (!p.keepWaiting)
        return { reEnqueue: false };
    const nextAttempt = p.current.attempt + 1;
    if (nextAttempt >= p.current.maxAttempts)
        return { reEnqueue: false }; // budget exhausted — give up gracefully
    const delayMs = Math.min(AWAIT_TXNS_BASE_DELAY_MS * Math.pow(2, p.current.attempt), AWAIT_TXNS_MAX_DELAY_MS);
    return { reEnqueue: true, next: { attempt: nextAttempt, maxAttempts: p.current.maxAttempts }, delayMs };
}
//# sourceMappingURL=queue.models.js.map